import { Component, Prop, Vue } from 'vue-property-decorator';
import appStore from '@/store/app';
import erpStore from '@/store/erp';
import authenticator from '@/store/authentication';
import CardComponent from '@/components/CardComponent';
import EditToolbar from '@/components/EditToolbar';
import { MarketAd, MarketAdType, SelectItem, UserProfile } from '@/types';
import { addDays } from '@/filters';

@Component({
    components: { CardComponent, EditToolbar },
  })
export default class ErpMarketDetail extends Vue {

    // Injectectd from url
    @Prop({ default: 0 }) private readonly id!: number;

    get marketAd(): MarketAd {

        if (this.id > 0) {
            const marketAds = erpStore.marketAds.filter((m) => m.id === this.id);
            if (marketAds && marketAds.length > 0) {
                return marketAds[0];
            }
        }

        const currentUser = authenticator.userProfile || { company: '', address: '', phone_number: '' } as UserProfile;

        return {
            id: 0,
            createdAt: new Date(),
            title: '',
            message: '',
            partnerName: currentUser.company + ' - ' + (currentUser.address || '') + ' Tel: ' + (currentUser.phone_number || ''),
            type: MarketAdType[MarketAdType.RC],
            expiryDate: addDays(new Date(), 10),
         } as MarketAd;
    }

    get loading(): boolean {
        return appStore.isLoading;
    }

    get types(): SelectItem<string>[] {
        return erpStore.marketTypes;
    }

    get isNewMarketAd(): boolean {
        return this.id === 0;
    }

    private async mounted() {
        await appStore.activateMenuById({rootId: 200, subMenuId: 201 });
    }

    private async save() {
        this.$buefy.dialog.confirm({
            title: 'Termina sessione',
            message: 'Sei sicuro/a di voler <b>salvare</b> l\'annuncio ?',
            confirmText: 'Conferma',
            cancelText: 'Annulla',
            type: 'is-info',
            hasIcon: true,
            onConfirm: async () => {
                await this.saveAsync();
            },
        });
    }

    private async saveAsync() {
        await erpStore.upsertMarketAdAsync(
            {
                id: this.marketAd.id,
                title: this.marketAd.title,
                message: this.marketAd.message,
                partnerName: this.marketAd.partnerName,
                type: this.marketAd.type,
                createdAt: this.marketAd.createdAt,
                expiryDate: this.marketAd.expiryDate!,
             })
             .then((result) => {
                 if (result) {
                    this.$router.go(-1);
                 }
             });
    }

    private cancel(): void {
        this.$router.go(-1);
    }

}